import { html, type TemplateResult } from 'lit-html';

/** Icons from the Catch set (assets/icons/sprite.svg, upstream) and the few this console adds (ctc-icons.svg). */
const CATCH = new Set(['add', 'edit', 'delete', 'view', 'confirm', 'close', 'settings', 'overview', 'users', 'logs', 'test-post', 'logout', 'chevron', 'menu', 'sun', 'moon', 'monitor']);
export type IconName =
  | 'add'
  | 'edit'
  | 'delete'
  | 'view'
  | 'close'
  | 'settings'
  | 'overview'
  | 'users'
  | 'logs'
  | 'test-post'
  | 'logout'
  | 'chevron'
  | 'menu'
  | 'sun'
  | 'moon'
  | 'monitor'
  | 'key'
  | 'plug'
  | 'mail';

/** Decorative by default: label the control that holds it (aria-label), not the icon. */
export function icon(name: IconName, cls = ''): TemplateResult {
  const file = CATCH.has(name) ? 'sprite.svg' : 'ctc-icons.svg';
  return html`<svg class="icon ${cls}" aria-hidden="true" focusable="false"><use href="assets/icons/${file}#${name}"></use></svg>`;
}
